import React, { useEffect, useState } from "react";
import { Input, Modal, Radio } from "antd";
import style from "./style.scss";
import { getWindowHeight } from "../../../services";
import ReversedRadio from "../ReversedRadio";
import SingleSelectHeader from "./SingleSelectHeader";

const MaxItem = 6;
const ItemHeight = 50;
const Padding = 73;

const SingleSelectModal = props => {
  const { value, visible, onCancel, options, title, allowClear, onChange, showPopular, dataSource } = props;

  const [visibleOptions, setVisibleOptions] = useState([]);

  useEffect(() => {
    resetVisibleOptions();
  }, [JSON.stringify(options), visible]);

  const resetVisibleOptions = () => {
    const { options } = props;
    const visibleOptions = [...options];

    setVisibleOptions(visibleOptions);
  };

  const handleFilterChange = e => {
    const { options } = props;
    const { value } = e.target;
    const filteredOptions = options.filter(o =>
      o.title.toLowerCase().includes(value.toLowerCase())
    );
    setVisibleOptions(filteredOptions);
  };

  const handleChange = e => {
    const { value } = e.target;
    onCancel(onChange(value));
  };

  const handleItemClick = itemValue => {
    const { value, onCancel } = props;
    if (itemValue === value) {
      onCancel();
    }
  };

  const handleClear = () => {
    onChange(undefined);
    onCancel()
  }

  const afterClose = () => {
    resetVisibleOptions();
  };
  const windowHeight = getWindowHeight();

  return (
    visible && (
      <Modal
        afterClose={afterClose}
        destroyOnClose
        closable={false}
        onCancel={onCancel}
        footer={null}
        visible={visible}
        style={{
          paddingBottom: 0,
          paddingTop: 0,
          marginBottom: 0,
          marginTop: 0,
          top:
            options.length > MaxItem
              ? (windowHeight - MaxItem * ItemHeight) / 2 - Padding
              : (windowHeight - options.length * ItemHeight) / 2 - Padding
        }}
        className={style.modal}
      >
        <SingleSelectHeader title={title} onCancel={onCancel} allowClear={allowClear} value={value} handleClear={handleClear} />
        {options.length > MaxItem ? (
          <Input placeholder="Filter" onChange={handleFilterChange} />
        ) : null}
        <Radio.Group
          value={value}
          style={{ maxHeight: MaxItem * ItemHeight }}
          onChange={handleChange}
          className={style.itemGroup}
        >
          {showPopular && visibleOptions.some(o => o.popular) ? (
            <React.Fragment>
              <div className={style.groupHeader}>{dataSource === "location" ? "Top lokacije" : "Top marke"}</div>
              {visibleOptions.filter(o => o.popular).map(option => (
                <div
                  role="presentation"
                  key={option.value}
                  className={style.item}
                  onClick={() => handleItemClick(option.value)}
                  style={option.style || {}}
                >
                  <ReversedRadio value={option.value} label={option.title} />
                </div>
              ))}
              <div className={style.groupHeader}>{dataSource === "location" ? "Ostale lokacije" : "Ostale marke"}</div>
              {visibleOptions.filter(o => !o.popular).map(option => (
                <div
                  role="presentation"
                  key={option.value}
                  className={style.item}
                  onClick={() => handleItemClick(option.value)}
                  style={option.style || {}}
                >
                  <ReversedRadio value={option.value} label={option.title} />
                </div>
              ))}
            </React.Fragment>
          ) : (
            visibleOptions.map(option => (
              <div
                role="presentation"
                key={option.value}
                className={style.item}
                onClick={() => handleItemClick(option.value)}
                style={option.style || {}}
              >
                <ReversedRadio value={option.value} label={option.title} />
              </div>
            ))
          )}
        </Radio.Group>
      </Modal>
    )
  );
};

SingleSelectModal.defaultProps = {
  visible: false,
  value: null,
  title: ""
};

export default SingleSelectModal;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleSelectModal/index.tsx